import React from "react";
import HalfSemiChart from "../../../components/HalfSemiChart";
import HalfRadialChart from "./HalfRadialChart";

const TokenomicsCard = () => {
	return (
		<>
			<div className="token-card">
				<div className="token-card-bottom">
					<h6>Tokenomics</h6>
					<div className="mb-4 pb-lg-1">
						<HalfRadialChart />
					</div>
					<div className="token-card-middle">
						<div className="token-items">
							<div className="token-item">
								<HalfSemiChart color="#22C55C" fill="50" />
								<div className="token-item-cont">
									<div>Presale</div>
									<h6>84.0k</h6>
								</div>
							</div>
							<div className="token-item">
								<HalfSemiChart color="#2263C5" fill="25" />
								<div className="token-item-cont">
									<div>Liquidity</div>
									<h6>42.6K</h6>
								</div>
							</div>
							<div className="token-item">
								<HalfSemiChart color="#FFAA35" fill="20" />
								<div className="token-item-cont">
									<div>Team</div>
									<h6>21.2K</h6>
								</div>
							</div>
							<div className="token-item">
								<HalfSemiChart color="#FF3559" fill="15" />
								<div className="token-item-cont">
									<div>Locked</div>
									<h6>18.1K</h6>
								</div>
							</div>
							<div className="token-item">
								<HalfSemiChart color="#5D35FF" fill="10" />
								<div className="token-item-cont">
									<div>Unlocked</div>
									<h6>8.3K</h6>
								</div>
							</div>
							<div className="token-item">
								<HalfSemiChart color="#17BEE2" fill="5" />
								<div className="token-item-cont">
									<div>Burnt</div>
									<h6>2.2K</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default TokenomicsCard;
